import { z } from 'zod';

import { SupplierPaymentTermsKindSchema } from './supplier-role.schemas.js';

export const UpdateSupplierRoleBodySchema = z
  .object({
    paymentTermsKind: SupplierPaymentTermsKindSchema.optional(),
    paymentDays: z.number().int().positive().nullable().optional(),
    internalCode: z.string().trim().max(50).nullable().optional(),
    notes: z.string().trim().max(2000).nullable().optional(),
  })
  .superRefine((body, ctx) => {
    if (body.paymentTermsKind === 'NET_DAYS' && body.paymentDays === null) {
      ctx.addIssue({
        code: 'custom',
        message: 'paymentDays required for NET_DAYS',
        path: ['paymentDays'],
      });
    }
    if (
      body.paymentTermsKind !== undefined &&
      body.paymentTermsKind !== 'NET_DAYS' &&
      body.paymentDays != null
    ) {
      ctx.addIssue({
        code: 'custom',
        message: 'paymentDays must be null',
        path: ['paymentDays'],
      });
    }
  });

export type UpdateSupplierRoleBody = z.infer<typeof UpdateSupplierRoleBodySchema>;

export const UpdateSupplierRoleResponseSchema = z.object({
  supplierRoleId: z.uuid(),
});

export type UpdateSupplierRoleResponse = z.infer<typeof UpdateSupplierRoleResponseSchema>;
